type ClassName = {
  className: string;
  include?: boolean;
};

/**
 * Merges a list of class names based on if they fulfil the conditional set by include. If include is undefined, it will include the class name.
 * @param classNameList a list of type ClassName containing both the className and the boolean include
 * @returns a merged class names string
 */
export const mergeClassNames = (classNameList: ClassName[]): string =>
  classNameList
    .filter((className) => className.include !== false)
    .map((className) => className.className)
    .join(' ');
